export const MAX_STACK_TRACE_SIZE_BYTES = 32 * 1024;
export const MAX_SESSION_TIME_MS = 24 * 60 * 60 * 1000; // 1 day
